import React, { useState, useEffect, useContext } from 'react';
import localization from 'assets/localization/localization';
import { ArrowRight, tick, arrowRightBlue } from 'assets/images/imageData';
import Images from 'assets/images/imageData';
import PocForm from 'components/sales/formSection/pocForm/pocForm';
import Layout from 'components/sales/layout/layout';
import { Button } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const AddPoc = ({
  match,
  addPoc,
  pocById,
  getPocData,
  editPoc,
  getPocById,
  history
}) => {
  const { id } = useParams();
  const { baseUrl } = useContext(BaseUrl);

  const [isFiled, setIsFiled] = useState(false);
  const pocInputs = {
    pocDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [pocData, setCorporateData] = useState(pocInputs);
  const [leadId, setleadId] = useState();

  useEffect(() => {
    if (id) {
      (async () => {
        await getPocById(id);
      })();
    }
  }, []);
  const handleSubmit = async () => {
    const { pocDetails } = pocData;
    if (pocDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      if (id) {
        if (pocDetails.name !== '') {
          const res = await editPoc(pocDetails);
          if (res) {
            setIsModal(true);
          }
        }
      } else {
        if (pocDetails.name !== '') {
          const res = await addPoc(pocDetails);
          if (res) {
            setIsModal(true);
          }
        }
      }
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/viewPoc/${leadId}`);
  };

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.submitDtl}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  const handlePocSubmit = (val) => {
    setCorporateData({ ...pocData, pocDetails: val });
  };
  useEffect(() => {
    setleadId(match.params.leadId);
  }, []);

  return (
    <Layout
      title={id ? 'localization.editPoc' : localization.addPoc}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
    >
      <PocForm
        pocById={pocById}
        handleValue={handlePocSubmit}
        id={id ? id : null}
        leadId={leadId}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.pocSucces}</h5>
          <Link
            to={`${baseUrl}/viewPoc/${leadId}`}
            className="btn btn-primary mb-4"
          >
            {localization.pocList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

AddPoc.propTypes = {};

export default AddPoc;
